// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"looped-loading-bar_progressBar__3jpXF","loopedLoadingBar":"looped-loading-bar_loopedLoadingBar__Uxs7Y","animateGradient":"looped-loading-bar_animateGradient__6XZ3Q"};